// extracted by mini-css-extract-plugin
export default {"OptionsMenu":"OptionsMenu_OptionsMenu__NYNQI","optionsItem":"OptionsMenu_optionsItem__GnRHF"};